import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from "recharts";

import NorthEastIcon from "@mui/icons-material/NorthEast";
import CheckIcon from "@mui/icons-material/Check";

const data = [
  { month: "Jan", tax: 280000, ded: 150000 },
  { month: "Feb", tax: 280000, ded: 150000 },
  { month: "Mar", tax: 210000, ded: 0 },
  { month: "Apr", tax: 210000, ded: 85000 },
  { month: "May", tax: 210000, ded: 150000 },
];

const TaxDeductionTrend = () => {

  // 🔥 Custom Tooltip (LIKE IMAGE)
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          background: "#fff",
          padding: "10px",
          borderRadius: "5px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
          fontSize: "13px",
          border: "1px solid #eee",
        }}>
          <strong>{label}</strong>

          <div style={{ marginTop: 5 }}>
            <span style={{ color: "#0f4c5c" }}>●</span> Line 1:
            <b> ${(payload[0].value / 1000).toFixed(0)}k</b>
          </div>

          <div>
            <span style={{ color: "#f26522" }}>●</span> Line 2:
            <b> ${(payload[1].value / 1000).toFixed(0)}k</b>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <Card className="h-100" sx={{ borderRadius: "5px", border: "1px solid #eee" }}>
      <CardContent>

        {/* TITLE */}
        <Typography fontWeight={600} mb={2}>
          6 Months Tax & Deduction Trend
        </Typography>

        {/* CHART */}
        <Box sx={{ width: "100%", height: 260 }}>
          <ResponsiveContainer>
            <LineChart data={data}>
              
              {/* GRID */}
              <CartesianGrid strokeDasharray="3 3" vertical />

              {/* X */}
              <XAxis dataKey="month" />

              {/* Y */}
              <YAxis
                domain={[0, 350000]}
                ticks={[0, 87500, 175000, 262500, 350000]}
                tickFormatter={(v) => `$${v / 1000}k`}
              />

              {/* TOOLTIP */}
              <Tooltip content={<CustomTooltip />} />

              {/* 🔥 STEP LINES */}
              <Line
                type="stepAfter"
                dataKey="tax"
                stroke="#0f4c5c"
                strokeWidth={3}
                dot={{ r: 5 }}
              />

              <Line
                type="stepAfter"
                dataKey="ded"
                stroke="#f26522"
                strokeWidth={3}
                dot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </Box>

        {/* FOOTER */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
          flexWrap="wrap"
        >
          {/* VALUE */}
          <Box display="flex" alignItems="center" gap={1}>
            <Typography fontWeight={600}>$1.71M</Typography>

            <Box
              sx={{
                width: 26,
                height: 26,
                borderRadius: "50%",
                bgcolor: "#22c55e",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <NorthEastIcon sx={{ fontSize: 14, color: "#fff" }} />
            </Box>
          </Box>

          {/* LEGEND */}
          <Box display="flex" gap={3}>
            <Box display="flex" alignItems="center" gap={1}>
              <Box sx={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                bgcolor: "#0f4c5c",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <CheckIcon sx={{ fontSize: 10, color: "#fff" }} />
              </Box>
              <Typography fontSize={12}>Federal Tax</Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
              <Box sx={{
                width: 14,
                height: 14,
                borderRadius: "50%",
                bgcolor: "#f26522",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <CheckIcon sx={{ fontSize: 10, color: "#fff" }} />
              </Box>
              <Typography fontSize={12}>Deductions</Typography>
            </Box>
          </Box>
        </Box>

      </CardContent>
    </Card>
  );
};

export default TaxDeductionTrend;